import { v7 as uuid } from "uuid"

const externalData = [
  // {
  //   id: uuid(),
  //   licenseName: "ACT High School Elements",
  //   title: "ACT High School Elements",
  //   category: "High School",
  //   url: "http://online.masteryprep.com/",
  //   program: "act",
  //   externalLink: true
  // },
  {
    id: uuid(),
    licenseName: "ACT Bell Ringers",
    title: "ACT Bell Ringers",
    category: "Elements",
    key: "eact",
    url: "/snap/teacher/elements/eact"
  },
  {
    id: uuid(),
    licenseName: "ACT Elements",
    title: "ACT Elements",
    category: "Elements",
    key: "act",
    url: "/snap/teacher/elements/act"
  },
  {
    id: uuid(),
    licenseName: "ACT Elements Middle School",
    title: "ACT Elements Middle School",
    category: "Middle School",
    key: "actms",
    url: "/snap/teacher/elements/actms"
  },
  {
    id: uuid(),
    licenseName: "SAT Elements",
    title: "SAT Elements",
    category: "Elements",
    key: "sat",
    url: "/snap/teacher/elements/sat"
  },
  {
    id: uuid(),
    licenseName: "DSAT Elements",
    title: "DSAT Elements",
    category: "Elements",
    key: "dsat",
    url: "/snap/teacher/elements/dsat"
  },
  {
    id: uuid(),
    licenseName: "TSIA2 Elements",
    title: "TSIA2 Elements",
    category: "Elements",
    key: "tsia2",
    url: "/snap/teacher/elements/tsia2"
  }
]

const getUrlParam = name => name.replace(/ /g, "-")

export const getLicensedNavs = licenseName => {
  let filteredNavs = externalData.filter(n => {
    const isLicensed = n.licenseName === licenseName
    return isLicensed
  })
  return filteredNavs.map(n => ({
    name: n.title,
    url: n.url,
    category: n.category,
    key: n.key
  }))
}

export const getItemByParam = (name, isStudent, studentAsset) => {
  if (studentAsset === "true") {
    isStudent = true
  }
  let filtered = externalData.filter(n => {
    return getUrlParam(n.title) === name && n.isStudentEbook === isStudent
  })
  return filtered.length ? filtered[0] : null
}

export default externalData
